export default {
  setSelectedTab: (state, payload) => {
    state.selectedTab = payload;
  },
}
